<template>
<div
    class="table-textArea"
    style="width: 100%; position: relative;"
>
  <textarea
      v-model="item.values"
      :class="item.class"
      :disabled="item.disabled"
      :maxlength="item.maxLength"
  >
  </textarea>
  <span class="text_area_length">
    {{isContentsValid}}/{{item.maxLength}}
  </span>
</div>
</template>
<script>
    export default {
        props: ['item'],
        methods: {
          // getByte(str) {
          //   return str.split('').map(s => s.charCodeAt(0)).reduce((prev, c) => (prev + ((c === 10) ? 2 : ((c >> 7) ? 2 : 1))), 0);
          // }
        },
        computed: {
            isContentsValid() {
                return this.item?.values ? this.item.values.length : 0
            }
        }
    }

</script>
<style lang="scss">
.note_layout_parent {
  .item-value {
    display: flex;
    flex-direction: column;
  }
}

.note_layout {
  height: 100%;
  max-height: 300px;
}

.text_area_length {
  display: block;
  font-size: 11px;
  color: var(--grey30);
  text-align: right !important;
}

.table-textArea {
  textarea:focus {
    border: 1px solid var(--blue70);
  }

  textarea:disabled {
    background-color: var(--grey10) !important;
  }
}
</style>